import * as React from 'react';

const NaranjaPaymentSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 36 24" {...props}>
        <defs>
            <linearGradient
                x1="29.752%"
                y1="100%"
                x2="58.907%"
                y2="20.558%"
                id="naranja-payment_svg__linearGradient-1"
            >
                <stop stopColor="#FFF" offset="0%" />
                <stop stopColor="#F5CAB9" offset="100%" />
            </linearGradient>
        </defs>
        <g
            id="naranja-payment_svg__Page-1"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g id="naranja-payment_svg__tarjeta-naranja">
                <rect
                    id="naranja-payment_svg__Rectangle"
                    fill="#FF6602"
                    x={0}
                    y={0}
                    width={36}
                    height={24}
                    rx={2}
                />
                <g
                    id="naranja-payment_svg__Group"
                    transform="translate(11 4)"
                    fillRule="nonzero"
                >
                    <path
                        d="M0 12V9.176c2.321-.003 4.202-1.903 4.204-4.247V3 1L7 2v2.929C7 8.827 3.86 12 0 12z"
                        id="naranja-payment_svg__Path"
                        fill="url(#naranja-payment_svg__linearGradient-1)"
                    />
                    <path
                        d="M12.324 0c.73 0 1.323.63 1.323 1.407v11.789c.112.37.063.775-.142 1.115a1.424 1.424 0 01-.563.527 1.262 1.262 0 01-.618.162h-.047a1.44 1.44 0 01-1.26-.74L4.172 2.08A1.39 1.39 0 014.211.672C4.479.242 4.959-.013 5.47 0c.51.013.975.293 1.22.736l4.309 7.673L11 1.407C11 .63 11.593 0 12.324 0z"
                        id="naranja-payment_svg__Combined-Shape"
                        fill="#FFF"
                    />
                </g>
            </g>
        </g>
    </svg>
);

NaranjaPaymentSvg.displayName = 'NaranjaPaymentSvg';
export default NaranjaPaymentSvg;
